module.exports = __webpack_public_path__ + "img/phzjt1.9eda809c.jpeg";